import {ProcessFieldOptions} from "components/AutocompleteWithPermanentPlaceholder/AutocompleteWithPermanentPlaceholder.types";
import {createActions, createReducer} from "reduxsauce";

type initial = {
  allProcessFields: ProcessFieldOptions[];
};

const INITIAL_STATE: initial = {
  allProcessFields: [],
};

export const {Types, Creators} = createActions({
  setFieldsFromProcess: ["allProcessFields"],
});

const setFieldsFromProcess = (state = INITIAL_STATE, action: initial) => ({
  ...state,
  allProcessFields: action.allProcessFields,
});

export default createReducer(INITIAL_STATE, {
  [Types.SET_FIELDS_FROM_PROCESS]: setFieldsFromProcess,
});
